// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-icon-edit-outline[data-v-34577cd6] {\n  margin-right: 10px;\n}\n.el-icon-delete[data-v-34577cd6] {\nspan {\n    margin-left: 4px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
